// extracted by mini-css-extract-plugin
module.exports = {"editor":"SectionEditor_editor__AiKM9","actions":"SectionEditor_actions___EdVl"};